
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trait-shuffle",
      function () {
        return require("private-next-pages/trait-shuffle/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trait-shuffle"])
      });
    }
  